import { connect } from 'react-redux'
import { clearItems, createList } from 'components/Items/actions'
import component from './component'


const mapStateToProps = state => ({
    isVisible: !!state.items.ids.length
})

export default connect(
    mapStateToProps,
    {
        clearItems,
        createList
    }
)(component)
